export const ERROR_CODE = {
  SUCCESS: 0,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500
} as const

export const HTTP_STATUS_MESSAGE: Record<number, string> = {
  [ERROR_CODE.BAD_REQUEST]: '请求参数错误',
  [ERROR_CODE.UNAUTHORIZED]: '未登录或登录已过期，请重新登录',
  [ERROR_CODE.FORBIDDEN]: '没有权限访问该资源',
  [ERROR_CODE.NOT_FOUND]: '请求的资源不存在',
  [ERROR_CODE.UNPROCESSABLE_ENTITY]: '请求处理失败',
  [ERROR_CODE.INTERNAL_SERVER_ERROR]: '服务器内部错误'
} as const

/**
 * 业务错误码 → 对用户友好的中文描述
 * 供各接口调用方使用，不在全局拦截器中自动弹出
 */
export const BUSINESS_ERROR_MESSAGE: Record<number, string> = {
  // ── 认证/授权 (10xxx) ──
  10001: '用户名或密码错误',
  10002: '邮箱格式不正确',
  10003: '该邮箱尚未注册',
  10004: '该邮箱已被注册',
  10005: '该用户名已被使用',
  10006: '验证码错误',
  10007: '验证码已过期',
  10008: '密码强度不足',
  10009: '登录已失效，请重新登录',
  10010: '登录已失效，请重新登录',
  10011: '账号未激活，请先验证邮箱',
  10012: '确认邮件链接已失效，请重新获取',
  10013: '密码重置链接已失效，请重新获取',
  10014: '邀请码不存在或已失效',
  // ── 用户 (20xxx) ──
  20001: '用户不存在',
  20002: '账号已被禁用',
  20003: '当前密码错误',
  20004: '该邮箱已被使用',
  // ── 文件 (30xxx) ──
  30001: '未选择文件',
  30002: '文件类型不允许',
  30003: '文件大小超过限制',
  30004: '文件不存在',
  30005: '文件上传失败',
  // ── 智能体 (40xxx) ──
  40001: '智能体不存在',
  40002: '智能体已禁用',
  40003: '未配置供应商密钥',
  40004: '供应商密钥已失效',
  40005: '智能体 API 调用失败',
  // ── 聊天/会话 (50xxx) ──
  50001: '会话不存在',
  50002: '无权访问该会话',
  50003: '消息内容为空',
  // ── 通用校验 (60xxx) ──
  60001: '请求参数校验失败',
  60002: '数据不存在',
  60003: '操作不允许',
  // ── 系统 (90xxx) ──
  90001: '服务内部错误',
  90002: '第三方服务不可用',
  90003: '第三方服务超时',
  90004: '数据库操作失败'
} as const

/**
 * 根据业务错误码获取可读错误消息
 */
export function getBusinessErrorMessage(code: number): string {
  return BUSINESS_ERROR_MESSAGE[code] || `未知错误 (${code})`
}

export type ErrorCodeType = (typeof ERROR_CODE)[keyof typeof ERROR_CODE]
